import styled from 'styled-components';
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default FlexContainer;
